import type { AdminConnectedPlatform } from "../modules/types";
import { adminApiGet } from "./utils";

export const adminConnectedPlatformsApi = {
  getAll: (workspaceId?: string): Promise<AdminConnectedPlatform[]> =>
    adminApiGet<AdminConnectedPlatform[]>(
      workspaceId
        ? `/connected_platforms?workspace_id=${encodeURIComponent(workspaceId)}`
        : "/connected_platforms",
    ),

  getById: (id: string): Promise<AdminConnectedPlatform> =>
    adminApiGet<AdminConnectedPlatform>(`/connected_platforms/${id}`),
};
